// | Additional utilities for dealing generically with records.
// | "2" is appended to the name to avoid conflict with `purescript-record-extra`.
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Record$dExtra from "../Record.Extra/index.js";
import * as Record$dUnsafe from "../Record.Unsafe/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
const maybeGet$pTrue = dictIsSymbol => () => ({"maybeGet'": x => Data$dMaybe.$Maybe("Just", Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(x))});
const maybeGet$pFalse = {"maybeGet'": v => Data$dMaybe.Nothing};
const rsequence = () => dictApplicative => dictSequenceRecord => Record$dExtra.sequenceRecord()(dictSequenceRecord);
const rsequence2 = dictFunctor => () => dictApplicative => dictSequenceRecord => {
  const rsequence4 = Record$dExtra.sequenceRecord()(dictSequenceRecord);
  return () => dictApplicative1 => {
    const map = dictApplicative1.Apply0().Functor0().map;
    return dictSequenceRecord1 => {
      const $0 = map(rsequence4);
      const $1 = Record$dExtra.sequenceRecord()(dictSequenceRecord1);
      return x => $0($1(x));
    };
  };
};
const rowListIntersection = () => () => () => () => dictIsBoolean => x => y => {
  if (dictIsBoolean.reflectBoolean(Type$dProxy.Proxy)) { return x; }
  return y;
};
const rliNilYS = {};
const rliNilXS = {};
const rliNilNil = {};
const rliMatch = () => () => ({});
const rliConsCons = () => () => () => () => () => ({});
const maybeGet$p = dict => dict["maybeGet'"];
const maybeGet1 = () => dictMaybeGet$p => ({maybeGet: dictMaybeGet$p["maybeGet'"]});
const maybeGet = dict => dict.maybeGet;
const mapFieldRecordNil = {mapFieldRecordImpl: v => v1 => v2 => ({})};
const mapFieldRecordImpl = dict => dict.mapFieldRecordImpl;
const mapFieldRecordCons = dictIsSymbol => () => dictMapFieldRecord => () => () => (
  {
    mapFieldRecordImpl: v => f => r => Record$dUnsafe.unsafeSet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(f(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(r)))(dictMapFieldRecord.mapFieldRecordImpl(Type$dProxy.Proxy)(f)(r))
  }
);
const mapFieldRecord = () => dictMapFieldRecord => dictMapFieldRecord.mapFieldRecordImpl(Type$dProxy.Proxy);
export {
  mapFieldRecord,
  mapFieldRecordCons,
  mapFieldRecordImpl,
  mapFieldRecordNil,
  maybeGet,
  maybeGet$p,
  maybeGet$pFalse,
  maybeGet$pTrue,
  maybeGet1,
  rliConsCons,
  rliMatch,
  rliNilNil,
  rliNilXS,
  rliNilYS,
  rowListIntersection,
  rsequence,
  rsequence2
};
